import * as React from 'react';
import Button from '@components/actions/button';
import PlusIcon from '@components/basics/icons/plus';
import Typography from '@components/basics/typography';
import Flex from '@components/layout/flex';
import styled from 'styled-components';
import UploadSongCtrl from '@webapp/controllers/upload/upload-song';
import { Translate } from 'react-localize-redux';
import MotionOpacity from '@components/motion/motion-opacity';

export interface AddSongProps {
  className?: string;
  locked?: boolean;
  releaseId?: string;
}

export const AddSong: React.FC<AddSongProps> = (props) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [trackingId, setTrackingId] = React.useState<string>();

  return (
    <Flex flexDirection="column" className={props.className}>
      <Flex alignItems="center" onClick={() => setIsOpen(!isOpen)}>
        <Button
          circleSize={32}
          buttonType="circle-black"
          className="icon-btn"
          customContent={<PlusIcon size={10} close={isOpen} isWhite />}
        />
        <Typography weight="700" className="text">
          <Translate id="RELEASE.SIDEBAR.LIST.ADD" />
        </Typography>
      </Flex>
      {isOpen && (
        <MotionOpacity>
          <UploadSongCtrl
            className="mt-10"
            inline
            inSidebar
            trackingId={trackingId}
            releaseId={props.releaseId}
            onTrackingId={setTrackingId}
            locked={props.locked}
            onEnd={() => {
              setIsOpen(false);
              setTrackingId(undefined);
            }}
          />
        </MotionOpacity>
      )}
    </Flex>
  );
};

export default styled(AddSong)`
  margin-top: 20px;

  ${(props) => (props.locked ? `pointer-events: none; opacity: .5;` : null)}

  .selector {
    cursor: pointer;
  }

  .icon-btn {
    margin-right: 10px;
    width: 24px;
    height: 24px;
    padding: 0;
  }
`;
